import styled from "styled-components";
import { motion } from "framer-motion";

export const Card = styled(motion.button)`
    width: 100%;
    height: 80px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 13px;
    border: none;
    background: transparent;
    border: thin solid var(--border-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 3px;
    color: var(--text-color);
    position: relative;
    cursor: pointer;

    :is([data-color = green]) {
        background: #5DA57D;
        background: -webkit-linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        background: -moz-linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        background: linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5DA57D", endColorstr="#7EBD61", GradientType=1);
        
        p.Card__title, p.Card__value {
            color: #fff;
        }
    }
    
    :is([data-color = red]) {
        background: #DC143C;
        background: -webkit-linear-gradient(90deg, rgba(220, 20, 60, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(241, 95, 87, 1) 100%);
        background: -moz-linear-gradient(90deg, rgba(220, 20, 60, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(241, 95, 87, 1) 100%);
        background: linear-gradient(90deg, rgba(220, 20, 60, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(241, 95, 87, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#DC143C", endColorstr="#F15F57", GradientType=1);
        
        p.Card__title, p.Card__value {
            color: #fff;
        }
    }

    :is([data-color = yellow]) {
        background: #FFD700;
        background: -webkit-linear-gradient(90deg, rgba(255, 215, 0, 1) 0%, rgba(255, 236, 0, 1) 50%, rgba(255, 215, 0, 1) 100%);
        background: -moz-linear-gradient(90deg, rgba(255, 215, 0, 1) 0%, rgba(255, 236, 0, 1) 50%, rgba(255, 215, 0, 1) 100%);
        background: linear-gradient(90deg, rgba(255, 215, 0, 1) 0%, rgba(255, 236, 0, 1) 50%, rgba(255, 215, 0, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFD700", endColorstr="#FFD700", GradientType=1);
    }

    p.Card__title {
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        padding: 0;
        margin: 0;
    };

    p.Card__value {
        font-weight: 700;
        font-size: 2.200vw;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        line-height: 35px;
        color: var(--text-color);
    }

    img.Card__icon {
        position: absolute;
        bottom: 10px;
        right: 10px;
        width: 40px
    }
`;